<script setup>
import { computed } from 'vue'
import { useRegistryStore } from '@/stores/registry.store'

import GridDropDownBox from '@/components/shared/GridDropDownBox.vue'
import ArrayStore from 'devextreme/data/array_store'
import DataSource from 'devextreme/data/data_source'

const registryStore = useRegistryStore()

const emit = defineEmits({
  valueChanged: (e) => true,
})
const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  disabled: { type: Boolean, default: false },
  value: {
    type: Number,
    default: null,
  },
})

const data = props.value || props.data?.value

const defaultDataSource = computed(() => {
  const store = new ArrayStore({
    data: registryStore.getLocalizedDeposits(),
    key: 'id',
  })

  const dataSourceOptions = {
    store: store,
    searchExpr: ['code', 'name'],
    sort: 'code',
  }

  return new DataSource(dataSourceOptions)
})

const valueChanged = (e) => {
  emit('valueChanged', { value: e })
  props.data?.setValue(e)
}
</script>

<template>
  <grid-drop-down-box
    :value="data"
    :data-source="defaultDataSource"
    :remote-operations="false"
    :columns="[
      { dataField: 'code', caption: $t('common.code'), width: '5rem' },
      { dataField: 'name', caption: $t('common.name') },
      { dataField: 'address.city_name', caption: $t('common.city') },
      { dataField: 'address.street', caption: $t('common.street') },
    ]"
    :drop-down-options="{ width: 700 }"
    :disabled="props.disabled"
    @value-changed="valueChanged"
  />
</template>
